<template>
  <div class="fab-wrap">
    <v-menu
      v-model="menuOpen"
      :close-on-content-click="false"
      offset-y
      transition="scale-transition"
      bottom
      right
      origin="bottom right"
      content-class="fab-menu"
    >
      <template v-slot:activator="{ on }">
        <v-btn class="fab-main" color="red" dark fab v-on="on">
          <v-icon>{{ menuOpen ? "close" : "menu" }}</v-icon>
        </v-btn>
      </template>
      <v-list class="fab-actions">
        <v-list-tile to="/" @click="menuOpen = false">
          <v-list-tile-avatar>
            <v-icon>home</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="authenticated"
          @click="
            logOff();
            menuOpen = false;
          "
        >
          <v-list-tile-avatar>
            <v-icon>person_outline</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Log out</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-else to="/login" @click="menuOpen = false">
          <v-list-tile-avatar>
            <v-icon>person</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Log in</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/user-guide" @click="menuOpen = false">
          <v-list-tile-avatar>
            <v-icon>menu_book</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>User Guide</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="showBack"
          @click="
            goBack();
            menuOpen = false;
          "
        >
          <v-list-tile-avatar>
            <v-icon>arrow_back</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Back</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <slot name="extra" />
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { getAuth, signOut } from "firebase/auth";
import { authState } from "../utils/authState";

export default {
  name: "FloatingNav",
  props: {
    showBack: { type: Boolean, default: true },
  },
  data() {
    return { menuOpen: false };
  },
  computed: {
    authenticated() {
      return authState.user != null;
    },
  },
  mounted() {
    this.$root.$on("close-fab-menu", this.closeMenu);
  },
  beforeDestroy() {
    this.$root.$off("close-fab-menu", this.closeMenu);
  },
  methods: {
    closeMenu() {
      this.menuOpen = false;
    },
    goBack() {
      this.$router.go(-1);
    },
    logOff() {
      const auth = getAuth();
      signOut(auth).then(
        () => {},
        () => {}
      );
    },
  },
};
</script>

<style scoped>
.fab-wrap {
  position: fixed;
  bottom: max(1rem, env(safe-area-inset-bottom));
  right: max(1rem, env(safe-area-inset-right));
  z-index: 4;
}
@media (min-width: 768px) {
  .fab-wrap {
    bottom: 1.5rem;
    right: 1.5rem;
  }
}
.fab-main {
  box-shadow: 0 4px 14px rgba(183, 36, 36, 0.4) !important;
}
</style>

<style>
/* Global: menu is rendered in body via v-menu */
.fab-menu {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  min-width: 200px;
}
.fab-menu .v-list__tile {
  height: 48px;
}
</style>
